import { render, staticRenderFns } from "./TemplateMixin.vue?vue&type=template&id=3969c9fa&"
import script from "./TemplateMixin.vue?vue&type=script&lang=js&"
export * from "./TemplateMixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports